/**
 * @file        src/pages/api/LogMenu.jsx
 * @description API Management → Log Menu. Jump-off card to the live supplier
 *              log views. The platform keeps ONE set of logs (B2C = supplier
 *              traffic — TripJack is the only supplier), so these link to the
 *              existing live lists rather than duplicating them.
 * @author      Kinetika Labs
 * @created     2026-07-04
 * @changelog
 *   - 2026-07-04 Claude — Initial.
 *   - 2026-07-23 Claude — Surface the Hotel Booking List in the Hotel Logs group
 *                          so it matches Flight Logs (Booking List + Search Log).
 */
import { Link } from 'react-router-dom';
import PageHead from '../../components/PageHead';

function LogGroup({ title, links }) {
  return (
    <article className="panel glass" style={{ marginBottom: 16 }}>
      <h3 style={{ margin: '0 0 12px' }}>{title}</h3>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {links.map((l) => (
          <Link key={l.to} className="btn primary" to={l.to}>{l.label}</Link>
        ))}
      </div>
    </article>
  );
}

export default function LogMenu() {
  return (
    <>
      <PageHead title="Log Menu" subtitle="Supplier API logs · API Management" />

      <LogGroup
        title="Flight Logs"
        links={[
          { label: 'Booking List', to: '/flight/bookings' },
          { label: 'Search Log', to: '/flight/search-history' },
        ]}
      />
      <LogGroup
        title="Hotel Logs"
        links={[
          { label: 'Booking List', to: '/hotel/bookings' },
          { label: 'Search Log', to: '/hotel/search-log' },
        ]}
      />
    </>
  );
}
